import type { SearchType } from 'modules/search/types/SearchType';

export const searchTypes = [
  'JOB',
  'INTERNSHIP',
  'VOLOP',
  'EVENT',
  'ORG',
] satisfies SearchType[];
